import React, { useEffect } from 'react';
import Loading from '../components/Loading';
import { getMe, getLimits } from '../api/endpoints';
import { navigateTo } from '../utils/navigation';

export default function LoadingPage(): React.JSX.Element {
  useEffect(() => {
    void (async () => {
      try {
        await getMe();
        getLimits().catch(() => null);
        navigateTo('/');
      } catch {
        navigateTo('/login');
      }
    })();
  }, []);

  return <Loading />;
}
